export enum MediaResourceType {
  Logo = "Logo",
  Black = "Black",
  Other = "Other",
}
